export const config = {
  virtualMessagingAdditionalShopTitle: 'Our Partners host virtual appointments by video or phone call. You can book at any shop or select one nearer to you.',
  virtualMessagingSearchResultTitle: 'Shops offering virtual appointments near',
  virtualMessagingSearchResultDescription: 'If you can\'t find a slot at a shop nearby, you can book at any other shop.',
};
